import { render, staticRenderFns } from "./validated-multifile-input.vue?vue&type=template&id=47e794bd&scoped=true"
import script from "./validated-multifile-input.vue?vue&type=script&lang=js"
export * from "./validated-multifile-input.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e794bd",
  null
  
)

export default component.exports